/* Original Schedule shipment form, located within Modal Popup */
import {
    MediumPrimaryButton,
    MediumLinkButton,
    Checkbox,
    Radio,
    DropDown,
    DropItem,
    RadioGroup,
    PlainInput,
    AddressInput,
    PhoneInput,
} from "@worthy-npm/clarity";

import React from "react";
import I18n from "lib/i18n/i18n";
import UserActions from "lib/userActions";
import {
    getSlots,
    imageUrl,
    dataAutomationAttr,
    isMobile,
    ESTIMATED,
    NEW,
    DELIVERED,
    SHIPMENT_METHOD,
    STEP_ADDRESS,
    STEP_PICKUP,
    STEP_MESSAGE,
    STEP_PHONE,
} from "../../helpers/ApplicationHelper";
import { getItem } from "actions/item";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { schedulePickup, scheduleDropOff } from "../../actions/shipment";
import {
    acceptItemEstimation,
    generateShippingLabel,
} from "../../actions/item";
import _ from "lodash";

// TODO switch these two imports to React.lazy() since we don't need these components at first
import RequestShippingKit from "./requestShippingKit";
import PopupRequestShippingKitExperiment from "../popups/popupRequestShippingKitExperiment";

import WorthyApi from "lib/api/worthyApi";
import { DEFAULT_PHONE } from "../../constants/register";
const DROPOFF = "dropoff";
const OFFICE_DROPOFF = "office_dropoff";
const PICKUP = "pickup";
const PROPS = "props";
const SAME_ADDRESS = "same_address";
const NEW_ADDRESS = "new_address";

import { updateMissingDetails } from "actions/user";
import PropTypes, {oneOf} from "prop-types";
import Listing from "./../listing/listing";
import ScheduleShipmentModalPopup from "../popups/scheduleShipmentModalPopup";
import GA from '../../lib/ga';

class ScheduleShipment extends React.Component {
    constructor(props) {
        super(props);
        const {
            item,
            steps,
            Session,
        } = props;

        if (props.step) {
            this.source = PROPS;
        }

        this.steps = [...steps];

        if (props.ADO.user.phone === DEFAULT_PHONE) {
            this.steps.unshift(STEP_PHONE);
        }

        const step = this.steps.findIndex((step) => step === props.step);

        let initialState = {
            step: step > -1 ? step : 0,
            address: {},
            apt: null,
            addressInputValue: "",
            slots: [],
            isPrivateResidence: false,
            isNewAddress: !(item && item.shipment && item.shipment.formatted_address),
            sendAddressTypedEvent: true,
            withPhone: true,
            phoneInputValue: "",
            prevStep: 0,
            isPhoneValid: false,
            showPhoneValidationMessage: false,
        };

        this.assignEveryStepItsIndex();
        this.countSteps = this.steps.length;

        this.showAnimation = false;
        this.editAddressClicked = false;
        this.isMobile = isMobile();

        if (item && item.shipment && Session) {
            initialState["slots"] = getSlots(
                item.shipment.pickup_availability,
                Session.userData.local_time
            );
        }
        this.state = initialState;
        this.counter = 0;

        this.getPhoneSection = this.getPhoneSection.bind(this);
        this.getPickupSection = this.getPickupSection.bind(this);
        this.getMessageSection = this.getMessageSection.bind(this);
        this.getAddressSection = this.getAddressSection.bind(this);
    }

    getStepIndex(value) {
        return this.steps.findIndex((step) => step === value);
    }

    assignEveryStepItsIndex() {
        this.steps.forEach((step) => {
            this[`${step}StepIndex`] = this.getStepIndex(step);
        });
    }

    logAction = (message, params) => {
        UserActions.lightListingPage(message, params.itemId, params.version);
    };

    componentDidMount() {
        const { item, acceptItemEstimation } = this.props;

        if (
            item.bundle["workflow_state"] === ESTIMATED ||
            (item.bundle.jb && item.bundle.workflow_state === NEW)
        ) {
            acceptItemEstimation(item.id)
                .then(() => {})
                .catch(this.onError);
        }
    }

    onAddressSelected = (address) => {
        let compiledAddress = {};

        _.each(address.address_components, (component) => {
            compiledAddress[component.types[0]] = component.short_name;
        });
        this.setState(
            {
                address: {
                    street:
                        (compiledAddress["street_number"]
                            ? compiledAddress["street_number"] + " "
                            : "") +
                        (compiledAddress["route"]
                            ? compiledAddress["route"]
                            : ""),
                    city:
                        compiledAddress["locality"] ||
                        compiledAddress["sublocality_level_1"] ||
                        compiledAddress["administrative_area_level_3"],
                    state: compiledAddress["administrative_area_level_1"],
                    zipcode: compiledAddress["postal_code"],
                },
                formattedAddress: address.formatted_address,
            },
            () => {
                console.log(this.state.address);
            }
        );
        // FIXME address typed
    };

    onError = (error) => {
        console.error(error);
        this.showAnimation = true;
        this.setState({
            step: this.messageStepIndex,
            prevStep: this.state.step,
            processingRequest: false,
            error: "Something went wrong during scheduling shipment",
        });
        if (this.props.handleScrollDownLinkClick) {
            this.props.handleScrollDownLinkClick();
        }
    };

    setAptNumber = (value, toggleToPrivate) => {
        this.setState({ apt: value });
        if (toggleToPrivate) {
            this.setState({
                isPrivateResidence: !this.state.isPrivateResidence,
            });
        }
    };

    toggleSameOrNewAddress = (value) => {
        const { address } = this.props;

        if (value === SAME_ADDRESS) {
            this.setState({
                isNewAddress: false,
                address: { ...address },
            });
        } else {
            this.setState({
                isNewAddress: true,
                address: {},
                shipmentMethod: null,
                isPrivateResidence: false,
            });
        }
        // Edit address button clicked
        // FIXME: hotfix for radiogroup bug, it doesn't get updated after parent's rerender
        this.editAddressClicked = false;
    };

    setShipmentMethod = (value) => {
        const { item, version } = this.props;
        if (value === DROPOFF) {
            this.sendUserEvent("Drop-off radio button selected");
        } else if (value === OFFICE_DROPOFF) {
            this.logAction("Office Drop-off radio button selected", {
                itemId: item?.id,
                version: version,
            });
        }

        this.setState({ shipmentMethod: value });
    };

    prepareDropOffLocations = () => {
        const item = this.props.item;

        return new Promise((resolve, reject) => {
            let locations = {};
            return Promise.all(
                item.shipment.locations.map((loc) => {
                    return WorthyApi.getAddressFromGoogle(loc["address"]);
                })
            ).then((dropOffLocations) => {
                dropOffLocations.forEach((dropOffLocation, idx) => {
                    locations[idx] = {
                        name: item.shipment.locations[idx]["name"],
                        address:
                            dropOffLocation["data"]["results"][0][
                                "formatted_address"
                            ],
                    };
                });
                resolve(locations);
            });
        });
    };

    schedulePickupTime = () => {
        const { timeSlot, slots, step } = this.state;
        const { item, onSetCustomWrapperTitle } = this.props;
        if (!timeSlot) {
            this.setState({ processingRequest: false });
            return;
        }
        this.setState({ processingRequest: true });
        const chosenTimeSlot = slots.find(
            (slot) => slot.readyTimestamp === timeSlot
        );
        const id = item.id;
        let expectFullResponse = true;

        return this.prepareDropOffLocations()
            .then((locations) => {
                this.props
                    .schedulePickup(
                        id,
                        timeSlot,
                        chosenTimeSlot.companyCloseTime,
                        locations,
                        expectFullResponse
                    )
                    .then((data) => {
                        // console.log('choosePickupTime data is:', data);
                        if (this.state && this.state.stopAnimation) {
                            this.state.stopAnimation();
                        }
                        if (data.error) {
                            console.error(data);
                            this.setState({ error: true });
                            // this.messageStepIndex = 'pickup';
                            return this.onError(
                                "Something went wrong during schedulePickupTime"
                            );
                        }
                        console.log("...scheduling pickup is done");
                        if (this.props.onShipmentScheduled) {
                            this.props.onShipmentScheduled();
                        }
                        if (data.payload.status === 200) {
                            this.setState({
                                step: step + 1,
                                prevStep: step,
                                processingRequest: false,
                            });
                            if (chosenTimeSlot.earlySlot) {
                                this.sendUserEvent(
                                    `User scheduled early pickup. readyTimestamp: ${chosenTimeSlot.readyTimestamp} companyCloseTime: ${chosenTimeSlot.companyCloseTime}`
                                );
                            }
                            if (this.props.handleScrollDownLinkClick) {
                                this.props.handleScrollDownLinkClick();
                            }

                            if (this.props.onShipmentScheduledViaPopup) {
                                this.props.onShipmentScheduledViaPopup();
                            }
                            if (onSetCustomWrapperTitle) {
                                onSetCustomWrapperTitle(false);
                            }
                            // this.onSuccessShipmentSchedule(data.payload);
                        }
                    })
                    .catch((e) => {
                        this.setState({ error: e, processingRequest: true });
                        console.error(e);
                    });
            })
            .catch((e) => this.onError(e));
    };
    setDropOff = (stopAnimation) => {
        const { item, onSetCustomWrapperTitle } = this.props;
        const { step } = this.state;

        if (
            !item.shipment ||
            !item.shipment.locations ||
            !item.shipment.locations.length
        ) {
            stopAnimation();
            this.onError("Shipment locations are empty. Unable to set dropoff");
            console.error(
                "Shipment locations are empty. Unable to set dropoff"
            );
            return;
        }
        return this.prepareDropOffLocations().then((locations) => {
            this.props
                .scheduleDropOff(item.id, locations, true)
                .then((data) => {
                    stopAnimation();
                    if (data.error) {
                        return this.onError();
                    }
                    console.log("...setting drop-off is done");
                    if (this.props.onShipmentScheduled) {
                        this.props.onShipmentScheduled();
                    }
                    this.setState({
                        step: step + 1,
                        prevStep: step,
                        processingRequest: false,
                    });

                    // console.log("this.props.onShipmentScheduledViaPopup", this.props.onShipmentScheduledViaPopup);
                    if (this.props.onShipmentScheduledViaPopup) {
                        this.props.onShipmentScheduledViaPopup();
                    }
                    if (this.props.handleScrollDownLinkClick) {
                        this.props.handleScrollDownLinkClick();
                    }
                    if (onSetCustomWrapperTitle) {
                        onSetCustomWrapperTitle(false);
                    }
                })
                .catch((err) => this.onError(err));
        });
    };

    backButtonClick = (step, hasShipment = false) => {
        const { processingRequest } = this.state;
        if (step < 0 || processingRequest) {
            return;
        }
        if (step === this.addressStepIndex) {
            // Edit address button clicked
            // FIXME: hotfix for radiogroup bug, it doesn't get updated after parent's rerender
            this.editAddressClicked = true;
        }
        this.sendUserEvent(
            hasShipment
                ? "«Edit address» from Schedule Secure Shipment Form clicked"
                : "Back button clicked"
        );
        this.showAnimation = true;
        this.setState(
            {
                step: step - 1,
                prevStep: step,
                error: false,
                isNewAddress: false,
            },
            this.resetAnimationFlag
        );
    };

    sendUserEvent(message) {
        if (this.props.logger) {
            this.props.logger(message, {
                itemId: this.props.item.id,
                version: this.props.version,
            });
        } else {
            UserActions.listingPage(
                message,
                this.props.item.id,
                this.props.version
            );
        }
    }

    resetAnimationFlag = () => {
        return setTimeout(() => {
            this.showAnimation = false;
        }, 250);
    };

    nextButtonClick = async (stopAnimation) => {
        const {
            step,
            address,
            apt,
            timeSlot,
            error,
            shipmentMethod,
            isPrivateResidence,
            isNewAddress,
            isPhoneValid,
        } = this.state;

        const {
            item,
            Session,
            version,
            generateShippingLabel,
            onSetCustomWrapperTitle,
            onGenerateShippingLabel,
        } = this.props;

        const UD = Session.userData._userData;
        this.setState({
            processingRequest: true,
            stopAnimation: stopAnimation,
        });
        const addressIsEmpty = Object.keys(address).length === 0;

        if (step === this.phoneStepIndex) {
            stopAnimation();
            this.showAnimation = true;
            this.setState({
                showPhoneValidationMessage: true,
                processingRequest: false,
            });
            if (isPhoneValid) {
                this.sendUserEvent(
                    "Complete Phone number modal - clicked next"
                );
                this.setState({ step: step + 1, prevStep: step });
                this.updatePhone();
                if (onSetCustomWrapperTitle) {
                    onSetCustomWrapperTitle(false);
                }
            }
        }

        if (step === this.addressStepIndex) {
            if (error) {
                stopAnimation();
                return this.props.onClose(step, true);
            }
            if (this.source === PROPS) {
                if (addressIsEmpty && isNewAddress) {
                    // Edit pickup is open and no address is filled in
                    return this.stopProcessingFormImmediately(stopAnimation);
                }
            }

            if (isNewAddress) {
                await getItem(this.props.item.id, false, {}, true);
                this.setState({ shipmentMethod: null });
            }

            if (!isNewAddress) {
                this.showAnimation = true;
                this.setState({ step: step + 1, prevStep: step, processingRequest: false }, this.resetAnimationFlag);
                stopAnimation();
                return;
            } else if (!(isNewAddress && !addressIsEmpty)) {
                this.setState({ processingRequest: false });
                stopAnimation();
                return;
            }

            let addressForPickup = {
                street: address.street,
                city: address.city,
                state: address.state,
                zipcode: address.zipcode,
            };

            if (!isPrivateResidence && !apt) {
                // Neither of apt number nor private residency is chosen
                return this.stopProcessingFormImmediately(stopAnimation);
            } else if (apt) {
                addressForPickup["street2"] = apt;
            }

            generateShippingLabel(
                item.id,
                {
                    address: addressForPickup,
                    user: {
                        first_name: UD.first_name,
                        last_name: UD.last_name,
                    },
                    auto_correct: true,
                },
                true
            )
                .then((data) => {
                    if (data.payload && data.payload.errors) {
                        this.onError(data.payload.errors[0]);
                    }
                    if (
                        data.payload &&
                        data.payload.data &&
                        data.payload.data.item
                    ) {
                        if (data.payload.data.item.shipment) {
                            const availableSlots = getSlots(
                                data.payload.data.item.shipment
                                    .pickup_availability,
                                Session.userData.local_time
                            );
                            if (!availableSlots.length) {
                                this.sendUserEvent(
                                    `There are currently no available pickup time slots`
                                );
                            }
                            if (onGenerateShippingLabel) {
                                onGenerateShippingLabel();
                            }
                            this.showAnimation = true;
                            this.setState(
                                {
                                    slots: availableSlots,
                                    step: step + 1,
                                    prevStep: step,
                                    processingRequest: false,
                                    addressInputValue: "",
                                },
                                this.resetAnimationFlag
                            );
                        }
                    }
                    stopAnimation();
                })
                .catch(this.onError);
            this.sendUserEvent("Next button clicked - address provided");
            GA.lightListingSetUpShipmentPopupAddressProvided();
        }
        if (step === this.pickupStepIndex && !error) {
            //Error handling
            if (
                shipmentMethod !== DROPOFF &&
                shipmentMethod !== OFFICE_DROPOFF &&
                !timeSlot
            ) {
                return this.stopProcessingFormImmediately(stopAnimation);
            }
            if (
                (!shipmentMethod && Object.keys(item.shipment).length === 0) ||
                (!shipmentMethod && !timeSlot)
            ) {
                // No shipment method is chosen or shipment hasn't been generated
                this.sendUserEvent("Pickup/Drop-off modal presented");
                return this.stopProcessingFormImmediately(stopAnimation);
            } else if (shipmentMethod === PICKUP && !timeSlot) {
                // For pickup timeSlot parameter is required to be chosen
                return this.stopProcessingFormImmediately(stopAnimation);
            }
            //Error handling - finished
            if (shipmentMethod === DROPOFF) {
                GA.lightListingSetUpShipmentPopupDeliveryScheduled({
                    shipmentType: "fedexDropOff",
                });
                console.log("setting drop-off...");
                this.sendUserEvent("Finish drop-off button clicked");
                this.setDropOff(stopAnimation);
            } else if (shipmentMethod === OFFICE_DROPOFF) {
                GA.lightListingSetUpShipmentPopupDeliveryScheduled({
                    shipmentType: "officeDropOff",
                });
                this.logAction(
                    "Schedule office drop-off radio button clicked",
                    {
                        itemId: item?.id,
                        version: version,
                    }
                );
            } else if (timeSlot) {
                GA.lightListingSetUpShipmentPopupDeliveryScheduled({
                    shipmentType: "pickup",
                });
                console.log("scheduling pickup...");
                this.sendUserEvent("Schedule button clicked");
                this.schedulePickupTime();
            }
            this.showAnimation = true;
        }

        if (error) {
            this.showAnimation = true;
            // «Close» button in case of backend error
            this.onError(error);
            this.stopProcessingFormImmediately(stopAnimation);
            return this.props.onClose(step, true);
        }
    };

    stopProcessingFormImmediately(stopAnimation) {
        this.setState({ processingRequest: false });
        stopAnimation();
    }

    setTimeSlot = (slot) => {
        this.setState({
            timeSlot: slot,
            processingRequest: false,
            shipmentMethod: PICKUP, // Quite obvious since slots belong to Pickup
        });
        this.sendUserEvent(
            `Pickup time slots shown to the seller ${this.state.slots.length}: ` +
                this.state.slots
                    .map((slot) => `${slot["dayText"]} ${slot["timeText"]}`)
                    .join(",")
        );
    };

    onAddressTyped = (value) => {
        if (this.state.sendAddressTypedEvent) {
            WorthyApi.sendAddressTypedEvent(this.props.item.id);
            this.setState({ sendAddressTypedEvent: false });
        }
        this.setState({ addressInputValue: value, processingRequest: false });
    };

    updatePhone = () => {
        const user = this.props.ADO.user;
        updateMissingDetails({
            phone: this.state.phoneInputValue,
            user_id: user.id,
        });
    };

    onPhoneTyped = (value, isValid) => {
        this.setState({
            isPhoneValid: isValid,
            showPhoneValidationMessage: false,
            phoneInputValue: value.replace(/[\D\s._-]+/g, ""),
        });
    };

    isNextButtonDisabled = () => {
        const {
            step,
            phoneInputValue,
            isNewAddress,
            isPrivateResidence,
            addressInputValue,
            formattedAddress,
            apt,
            shipmentMethod,
            timeSlot,
        } = this.state;

        switch (this.steps[step]) {
            case STEP_PHONE:
                return phoneInputValue === "";
            case STEP_ADDRESS:
                return (
                    isNewAddress &&
                    ((!isPrivateResidence && !apt) ||
                        addressInputValue === "" ||
                        !formattedAddress)
                );
            case STEP_PICKUP:
                return (
                    (!isNewAddress && !shipmentMethod) ||
                    (shipmentMethod !== DROPOFF &&
                        shipmentMethod !== OFFICE_DROPOFF &&
                        (!timeSlot || !shipmentMethod))
                );
        }
    };

    getPhoneSection() {
        if (this.state.step === this.phoneStepIndex) {
            this.sendUserEvent("Complete Phone number modal - presented");
        }
        return (
            <form
                key={`step${this.phoneStepIndex}`}
                className={"settingScheduleShipmentForm "}
            >
                <p className={"description update-phone"} key={"update-phone"}>
                    {I18n.getString("listingPage::setUpShipmentStepPhoneStep")}
                </p>
                <div
                    className="phone-input phone-input-wrapper"
                    data-automation={dataAutomationAttr("phone-number-input")}
                >
                    <PhoneInput
                        label={I18n.getString("listingPage::labelPhone")}
                        autoFocus={true}
                        showValidationMessage={
                            this.state.showPhoneValidationMessage
                        }
                        change={this.onPhoneTyped}
                    />
                </div>
            </form>
        );
    }

    getAddressSection () {
        const {item} = this.props;
        const isShipmentWithAddress = !!(item.shipment && item.shipment.formatted_address)
        const {
            isNewAddress,
            processingRequest,
            isPrivateResidence,
            step,
            apt,
        } = this.state;

        const NEW_ADDRESS_SECTION = (
            <div className={"new-address-form-container address-input-wrapper"}>
                <div className={`address-inputs-container`}>
                    <div className="address-input">
                        <AddressInput
                            addressSelected={this.onAddressSelected}
                            label={I18n.getString("listingPage::labelAddress")}
                            errorMessage={I18n.getString(
                                "listingPage::addressErrorMessage"
                            )}
                            typingMessage={I18n.getString(
                                "listingPage::typingInMessage"
                            )}
                            placeholder={I18n.getString(
                                "itemPage::AddressWaiting::consts::placeholder"
                            )}
                            description={I18n.getString(
                                "itemPage::AddressWaiting::consts::onFocusMsgShort"
                            )}
                            showResultsDown={this.isMobile}
                            change={this.onAddressTyped}
                            disabled={!isNewAddress}
                        />
                    </div>
                    <div className="apt-number-input">
                        <PlainInput
                            name="apt-number-input"
                            label={I18n.getString("listingPage::labelApt")}
                            disabled={
                                (processingRequest && !apt) ||
                                isPrivateResidence ||
                                !isNewAddress
                            }
                            change={(value) => {
                                if (value.trim()) {
                                    this.setAptNumber(value);
                                } else {
                                    if (!isPrivateResidence) {
                                        this.setAptNumber(null);
                                    }
                                    this.setState({
                                        isPrivateResidence: false,
                                    });
                                }
                            }}
                            blur={(value) => {
                                if (value.trim()) {
                                    this.setState({
                                        isPrivateResidence: false,
                                    });
                                    this.setAptNumber(value);
                                }
                            }}
                        />
                    </div>
                </div>
                <div className={"private-residence checkbox-field-wrapper"}>
                    <Checkbox
                        key={"apt-is-private-checkbox"}
                        name="apt-is-private"
                        label={I18n.getString(
                            "listingPage::labelPrivateResidence"
                        )}
                        checked={isPrivateResidence}
                        onChange={() => {
                            this.setState({
                                isPrivateResidence: !isPrivateResidence,
                            });
                        }}
                        disabled={processingRequest || !isNewAddress}
                    />
                </div>
            </div>
        );

        if (isShipmentWithAddress) {
            return (
                <form
                    key={`step${this.addressStepIndex}`}
                    className={
                        "settingScheduleShipmentForm step-address address-editing"
                    }
                >
                    <p
                        className={"description"}
                        key={"step1-description"}
                    >{`Continue or enter a new address below.`}</p>
                    <div className="radio-group-placeholder">
                        {step === this.addressStepIndex ? (
                            <RadioGroup
                                name={"shipment-method"}
                                initialValue={SAME_ADDRESS}
                                disabled={processingRequest}
                                onChange={(value) =>
                                    this.toggleSameOrNewAddress(value)
                                }
                            >
                                <div className="continue-with-address radio-field-wrapper">
                                    <Radio
                                        value={SAME_ADDRESS}
                                        label={`<span>Continue with <b>${item.shipment.formatted_address}</b></span>`}
                                        disabled={false}
                                    />
                                </div>
                                <div className="new-address radio-field-wrapper">
                                    <Radio
                                        value={NEW_ADDRESS}
                                        label={I18n.getString(
                                            "listingPage::labelNewAddress"
                                        )}
                                        disabled={false}
                                    />
                                    {NEW_ADDRESS_SECTION}
                                </div>
                            </RadioGroup>
                        ) : null}
                    </div>
                </form>
            );
        } else {
            return (
                <form
                    key={`step${this.addressStepIndex}`}
                    className={"settingScheduleShipmentForm step-address"}
                >
                    <p
                        className={"description add-new-address"}
                        key={"step1-description"}
                    >
                        {I18n.getString(
                            `listingPage::${
                                this.addressStepIndex === 0
                                    ? "setUpShipmentStepAddressStepFirst"
                                    : "setUpShipmentStepAddressStep"
                            }`
                        )}
                    </p>
                    {NEW_ADDRESS_SECTION}
                </form>
            );
        }
    }

    getPickupSection() {
        const { item } = this.props;
        const { formattedAddress, shipmentMethod, processingRequest, slots } =
            this.state;

        const pickupAvailability = item.shipment && item.shipment.pickup_availability ? item.shipment.pickup_availability : [];
        const pickupAvailabilityIsEmpty =
            !pickupAvailability || pickupAvailability.length === 0;
        const noPickupSlots = pickupAvailabilityIsEmpty || !slots.length;

        return (
            <form
                key={`step${this.pickupStepIndex}`}
                className={"settingScheduleShipmentForm step-pickup"}
            >
                <p
                    className={"description"}
                    key={"step2-description"}
                    dangerouslySetInnerHTML={{
                        __html: I18n.getString(
                            noPickupSlots
                                ? "listingPage::setUpShipmentFedexNoResults"
                                : `listingPage::${
                                      this.pickupStepIndex > 1
                                          ? "setUpShipmentStepPickupStepLast"
                                          : "setUpShipmentStepPickupStep"
                                  }`
                        ).replace(
                            "%address%",
                            formattedAddress ||
                                (item.shipment &&
                                    item.shipment["formatted_address"])
                        ),
                    }}
                />
                {!(item.shipment && item.shipment.locations) &&
                pickupAvailabilityIsEmpty ? (
                    <p className="description">
                        {I18n.getString("listingPage::setUpShipmentFedexIssue")}
                    </p>
                ) : (
                    <RadioGroup
                        name={"shipment-method"}
                        initialValue={shipmentMethod || PICKUP}
                        disabled={processingRequest}
                        onChange={(value) => this.setShipmentMethod(value)}
                    >
                        <div
                            className={`pickup radio-field-wrapper ${
                                pickupAvailabilityIsEmpty || !slots.length
                                    ? " no-time-slots "
                                    : ""
                            }`}
                        >
                            <Radio
                                label={I18n.getString(
                                    "listingPage::labelRadioGroup"
                                )}
                                value={PICKUP}
                                disabled={
                                    pickupAvailabilityIsEmpty || !slots.length
                                }
                            />
                            {pickupAvailabilityIsEmpty || !slots.length ? (
                                <span className="radio-help">
                                    {I18n.getString("listingPage::noSlots")}
                                </span>
                            ) : (
                                <div
                                    className={"pickup-dropdown-container"}
                                    data-automation={dataAutomationAttr(
                                        "pickup-dropdown"
                                    )}
                                >
                                    <DropDown
                                        name="time-slot"
                                        change={(slot) =>
                                            this.setTimeSlot(slot)
                                        }
                                        placeholder={I18n.getString(
                                            "listingPage::choosePickupTimePlaceholder"
                                        )}
                                        disabled={
                                            processingRequest ||
                                            shipmentMethod === DROPOFF ||
                                            shipmentMethod === OFFICE_DROPOFF
                                        }
                                        marginVsides="xs"
                                    >
                                        {Object.entries(slots).map((slot) => {
                                            return (
                                                <DropItem
                                                    key={slot[0]}
                                                    label={`${slot[1]["dayText"]} ${slot[1]["timeText"]}`}
                                                    value={
                                                        slot[1][
                                                            "readyTimestamp"
                                                        ]
                                                    }
                                                />
                                            );
                                        })}
                                    </DropDown>
                                </div>
                            )}
                        </div>
                        <div
                            className={`drop-off radio-field-wrapper ${
                                pickupAvailabilityIsEmpty || !slots.length
                                    ? " no-time-slots "
                                    : ""
                            }`}
                            data-automation={dataAutomationAttr("dropoff")}
                        >
                            <Radio
                                value={DROPOFF}
                                label={I18n.getString(
                                    "listingPage::labelDropOff"
                                )}
                                data-automation={dataAutomationAttr("dropoff")}
                                disabled={processingRequest}
                            />
                            <span className="radio-help">
                                {I18n.getString(
                                    "listingPage::anyFedexLocation"
                                )}
                            </span>
                        </div>
                    </RadioGroup>
                )}
            </form>
        );
    }

    getMessageSection = () => {
        const { error, shipmentMethod } = this.state;
        if (error) {
            return (
                <form
                    key="error-with-fedex"
                    className={"settingScheduleShipmentForm step-error"}
                >
                    <p className={"description"}>
                        {I18n.getString("listingPage::setUpShipmentFedexIssue")}
                    </p>
                </form>
            );
        }
        return (
            <div
                key={`step${this.messageStepIndex}`}
                className={`settingScheduleShipmentForm step-message`}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: I18n.getString(
                            `listingPage::setUpShipmentPickupStep::${
                                shipmentMethod || PICKUP
                            }`
                        ),
                    }}
                />
                {this.renderPartnerLogos()}
            </div>
        );
    };

    renderPartnerLogos = () => {
        const { step } = this.state;
        return (
            <img
                className={`schedule-shipment-insurance-partners ${
                    step === this.countSteps ? "top" : ""
                }`}
                src={imageUrl("trust-logos.png")}
                key={"partners-logo"}
                alt="Our partners"
            />
        );
    };

    render() {
        this.counter++;
        const { shipmentMethod, processingRequest, step, error, prevStep } = this.state;

        const {
            item,
            onSetCustomWrapperTitle,
            isSKExperiment,
        } = this.props;

        const isShipmentWithAddress = !!(item.shipment && item.shipment.formatted_address)

        if (!item) return null;

        let nextButtonCaptionKey = "next";
        let nextButtonAutomationAttr = "next";
        const nextButtonDisabled = this.isNextButtonDisabled();
        // Disables animations on first render
        let animationStopperClass = "";

        if (!this.showAnimation) {
            animationStopperClass = " no-animation ";
        }

        if (step === this.pickupStepIndex) {
            nextButtonCaptionKey = "schedule";
            nextButtonAutomationAttr = "schedule";
            if (shipmentMethod === DROPOFF) {
                nextButtonCaptionKey = "finish";
                nextButtonAutomationAttr = "finish";
            }
        }

        if (error) {
            nextButtonCaptionKey = "close";
        }

        let STEPS_FORMS = [];

        this.steps.forEach((step, i) => {
            const method = `get${_.startCase(step)}Section`;
            STEPS_FORMS[i] = this[method]();
        });

        let LOGOS =
            step === this.stepMessageIndex ? null : this.renderPartnerLogos();

        if (isSKExperiment && !error) {
            if (item.shipping_kit && item.shipping_kit.status === DELIVERED) {
                // Well, you got Shipping Kit lately so why not to schedule a Pickup? Or drop it off already!
                STEPS_FORMS[2] = (
                    <div
                        key="packItIntoShippingKitYouGotPreviously"
                        className="settingScheduleShipmentForm step-message"
                    >
                        {item.shipment.shipment_method ===
                        SHIPMENT_METHOD["Drop Off"] ? (
                            <div>
                                <div className="step-three-drop-off">
                                    {I18n.getString(
                                        "shippingKit::allGood::dropOffSelected"
                                    )}
                                </div>
                                <div
                                    key="medium-link-button"
                                    className="medium-link-button-full-width"
                                >
                                    <MediumPrimaryButton
                                        text={I18n.getString(
                                            "shipmentInformation::schedulePickupButton"
                                        )}
                                        click={(stopAnimation) => {
                                            if (processingRequest) {
                                                return;
                                            }
                                            stopAnimation();
                                            if (onSetCustomWrapperTitle) {
                                                onSetCustomWrapperTitle(
                                                    I18n.getString(
                                                        "listingPage::scheduleShipmentTitle"
                                                    )
                                                );
                                            }
                                            if (!this.isMobile) {
                                                // FIXME: must be removed once SSSF will contain its title
                                                // Hack for closing popup and open it on required step on desktop
                                                // Due to difficulties with the popup's title update

                                                // FIXME: dirty hack since Popup._hide(true) doesn't work here
                                                window.dispatchEvent(
                                                    new Event("popstate")
                                                );

                                                return ScheduleShipmentModalPopup.initPopup(
                                                    {
                                                        logger: this.logAction,
                                                        step: STEP_PICKUP,
                                                        version:
                                                            Listing.version,
                                                        isSKExperiment,
                                                    }
                                                );
                                            }
                                            return this.backButtonClick(
                                                this.pickupStepIndex + 1,
                                                isShipmentWithAddress
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        ) : null}
                        {item.shipment.shipment_method ===
                        SHIPMENT_METHOD["Pickup"] ? (
                            <div>
                                {I18n.getString(
                                    "shippingKit::allGood::pickupScheduled"
                                )}
                            </div>
                        ) : null}
                    </div>
                );
                LOGOS = this.renderPartnerLogos();
            } else {
                // Request Shipping Kit Form
                STEPS_FORMS[2] = (
                    <div
                        key="stepShippingKit"
                        className="settingScheduleShipmentForm step-three"
                    >
                        <RequestShippingKit
                            logger={() => {}}
                            onSuccess={() => {
                                if (this.props.onShipmentScheduled) {
                                    // So in our case we'd like to close the modal
                                    this.props.onShipmentScheduled();
                                }
                            }}
                            onShowInnerPopup={() => {
                                if (this.isMobile) {
                                    // alert('onShowInnerPopup!')
                                    // So in our case we'd like to close the modal as well
                                    this.props.onRequestShippingKit();
                                } else {
                                    // The same old dirty hack to close popups
                                    // For desktop only
                                    window.dispatchEvent(new Event("popstate"));
                                    PopupRequestShippingKitExperiment.initPopup(
                                        {}
                                    );
                                }
                            }}
                        />
                    </div>
                );
            }
        }
        /* End the experiment */

        if (error) {
            STEPS_FORMS[1] = this.getMessageSection();
        }

        return (
            <div
                key="scheduleShipment"
                data-automation={dataAutomationAttr(
                    "schedule-secure-shipment-form"
                )}
                className={`scheduleShipment ${
                    processingRequest ? " in-progress" : ""
                }`}
            >
                <style>
                    {`
                        @keyframes step-${step}-Animation {
                          from {
                            transform: translate3d(-${
                                (100 / this.countSteps) * prevStep
                            }%, 0, 0);
                            visibility: visible;
                          }
                        
                          to {
                            transform: translate3d(-${
                                (100 / this.countSteps) * step
                            }%, 0, 0);
                          }
                        }
                    `}
                </style>
                <div
                    className={`schedule-shipment-slider-forms animation ${animationStopperClass}` }
                    style={{
                        width: `${this.countSteps * 100}%`,
                        animationName: `step-${step}-Animation`,
                        animationDuration: !animationStopperClass
                            ? "500ms"
                            : "0ms",
                    }}
                >
                    {STEPS_FORMS}
                </div>
                {step < STEPS_FORMS.length - 1 ? (
                    <div
                        key="navigation-buttons"
                        className={`navigation-buttons step-${step}`}
                    >
                        {step === this.pickupStepIndex ? (
                            <div
                                key="medium-link-button"
                                className="medium-link-button continue-button-wrapper"
                            >
                                <MediumLinkButton
                                    text={I18n.getString(
                                        `listingPage::${
                                            isShipmentWithAddress
                                                ? "editAddress"
                                                : "back"
                                        }`
                                    )}
                                    click={() => {
                                        if (processingRequest) {
                                            return;
                                        }
                                        return this.backButtonClick(
                                            step,
                                            isShipmentWithAddress
                                        );
                                    }}
                                />
                            </div>
                        ) : null}
                        <div
                            key="medium-primary-button"
                            className="medium-primary-button continue-button-wrapper"
                            data-automation={dataAutomationAttr(
                                nextButtonAutomationAttr
                            )}
                        >
                            <MediumPrimaryButton
                                text={I18n.getString(
                                    "listingPage::" + nextButtonCaptionKey
                                )}
                                data-automation={dataAutomationAttr(
                                    nextButtonAutomationAttr
                                )}
                                disabled={nextButtonDisabled}
                                click={(stopAnimation) => {
                                    if (
                                        nextButtonDisabled ||
                                        processingRequest
                                    ) {
                                        stopAnimation();
                                        return;
                                    }
                                    return this.nextButtonClick(stopAnimation);
                                }}
                            />
                        </div>
                    </div>
                ) : null}
                {(step < this.countSteps - 1 || ((step === this.countSteps - 1) && isSKExperiment)) ? LOGOS : null }
            </div>
        );
    }
}

const mapStateToProps = ({ ADO, Item, Session, Experiments, Personalized }) => {
    return {
        ADO,
        item: Item,
        Session,
        experiments: Experiments,
        P13N: Personalized,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            generateShippingLabel,
            schedulePickup,
            acceptItemEstimation,
            scheduleDropOff,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleShipment);

ScheduleShipment.propTypes = {
    step: oneOf([
        STEP_ADDRESS,
        STEP_PICKUP,
        STEP_MESSAGE,
        STEP_PHONE
    ]),
};

ScheduleShipment.defaultProps = {
    steps: [STEP_ADDRESS, STEP_PICKUP, STEP_MESSAGE],
};
